import { render, staticRenderFns } from "./AscRoleGridTemplate.vue?vue&type=template&id=fc21a712&"
import script from "./AscRoleGridTemplate.vue?vue&type=script&lang=js&"
export * from "./AscRoleGridTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports